import React, { useState } from "react";
import "../style/Form.css";
import ToastPop from "./ToastPop";
import ImgFondo from "../img/backgroundForm.webp";

const FormularioCorreo = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    asunto: "",
    mensaje: "",
  });

  const [errors, setErrors] = useState({
    nombre: "",
    email: "",
    telefono: "",
    asunto: "",
    mensaje: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Expresiones regulares para validación
  const regex = {
    nombre: /^[a-zA-Z\sáéíóúÁÉÍÓÚñÑ-]+$/u, // Solo letras, espacios, acentos y guiones
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/u, // Formato de email válido
    telefono: /^\+?\d{0,14}$/u, // Solo números, opcionalmente con "+" al inicio, máx. 14 dígitos
  };

  const validateField = (name, value) => {
    switch (name) {
      case "nombre":
        if (!value) return "El nombre es obligatorio";
        if (!regex.nombre.test(value)) return "El nombre solo puede contener letras, espacios o guiones";
        if (value.length > 50) return "El nombre no puede exceder los 50 caracteres";
        return "";
      case "email":
        if (!value) return "El email es obligatorio";
        if (!regex.email.test(value)) return "El email no es válido";
        return "";
      case "telefono":
        if (!value) return "El teléfono es obligatorio";
        if (!regex.telefono.test(value)) return "El teléfono solo puede contener números y opcionalmente un '+' al inicio";
        if (value.length < 8) return "El teléfono debe tener al menos 8 dígitos";
        return "";
      case "asunto":
        if (!value) return "El asunto es obligatorio";
        return "";
      case "mensaje":
        if (!value) return "El mensaje es obligatorio";
        if (value.length > 500) return "El mensaje no puede exceder los 500 caracteres";
        return "";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Filtrar caracteres no deseados en tiempo real
    let filteredValue = value;
    if (name === "telefono") {
      // Reemplazar cualquier carácter que no sea número o "+" al inicio
      filteredValue = value.replace(/[^0-9+]/g, "");
      if (filteredValue.startsWith("+")) {
        filteredValue = "+" + filteredValue.slice(1).replace(/\+/g, "");
      }
    } else if (name === "nombre") {
      // Reemplazar caracteres no permitidos en el nombre
      filteredValue = value.replace(/[^a-zA-Z\sáéíóúÁÉÍÓÚñÑ-]/gu, "");
    }

    setFormData({
      ...formData,
      [name]: filteredValue,
    });

    // Validar el campo y actualizar los errores
    setErrors({
      ...errors,
      [name]: validateField(name, filteredValue),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar todos los campos antes de enviar
    const newErrors = {
      nombre: validateField("nombre", formData.nombre),
      email: validateField("email", formData.email),
      telefono: validateField("telefono", formData.telefono),
      asunto: validateField("asunto", formData.asunto),
      mensaje: validateField("mensaje", formData.mensaje),
    };

    setErrors(newErrors);

    // Verificar si hay errores
    if (Object.values(newErrors).some((error) => error !== "")) {
      setMessage("❌ Por favor, corrige los errores en el formulario");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await fetch("/guardar.php", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.success) {
        setMessage("✅ Mensaje enviado correctamente");
        setFormData({
          nombre: "",
          email: "",
          telefono: "",
          asunto: "",
          mensaje: "",
        });
        setErrors({
          nombre: "",
          email: "",
          telefono: "",
          asunto: "",
          mensaje: "",
        });
        setShowModal(true);

        if (window.gtag) {
          window.gtag("event", "form_submit", {
            event_category: "Contacto",
            event_label: "Formulario enviado correctamente",
          });
        }
      } else {
        setMessage("❌ Error: " + result.error);
      }
    } catch (error) {
      setMessage("❌ Error de conexión");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
    id="formu" 
    className="form-container"
    >
      {/* <h1>Contactanos</h1> */}
    <img src={ImgFondo} alt="Fondo decorativo" className="form-background" />

      {message && !showModal && (
        <div
          className={`message ${message.includes("✅") ? "success" : "error"}`}
        >
          {message}
        </div>
      )}

      {showModal && (
        <ToastPop
          message="Tu mensaje fue enviado correctamente. Te responderemos pronto."
          redirect="/"
        />
      )}
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="nombre">Nombre completo *</label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
            placeholder="Tu nombre completo"
            aria-describedby={errors.nombre ? "nombre-error" : undefined}
          />
          {errors.nombre && <span className="error-message">{errors.nombre}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="tu@email.com"
             aria-describedby={errors.email ? "email-error" : undefined}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="telefono">Teléfono *</label>
          <input
            type="tel"
            id="telefono"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            required
            placeholder="+54 11 1234-5678"
            aria-describedby={errors.telefono ? "telefono-error" : undefined}
          />
          {errors.telefono && <span className="error-message">{errors.telefono}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="asunto">Asunto *</label>
          <select
            id="asunto"
            name="asunto"
            value={formData.asunto}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un asunto</option>
            <option value="Mudanzas">Mudanzas</option>
            <option value="Guardamuebles">Guardamuebles</option>
            <option value="Fletes">Fletes</option>
            <option value="Elevaciones">Elevaciones</option>
          </select>
          {errors.asunto && <span className="error-message">{errors.asunto}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="mensaje">Mensaje *</label>
          <textarea
            id="mensaje"
            name="mensaje"
            value={formData.mensaje}
            onChange={handleChange}
            required
            rows="4"
            placeholder="Describe tu consulta o solicitud..."
          />
          {errors.mensaje && <span className="error-message">{errors.mensaje}</span>}
        </div>

        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? "Enviando..." : "Enviar mensaje"}
        </button>
      </form>
    </div>
  );
};

export default FormularioCorreo;